import { isBrowserIOSIPadSafari } from '@/utils/device'

import type { PageAdType } from './types'

export type NativeBannerCoordinates = 'page' | 'screen'

export type NativeBannerSize = [number, number]

type NativeBannerAdaptive = { type: 'anchored' } | { type: 'inline'; maxHeight?: number }

type NativeBannerVariant = { minViewportWidth?: number; sizes: NativeBannerSize[] }

export type NativeBannerSlot = {
    sizes: NativeBannerSize[]
    tablet?: NativeBannerVariant[]
    adaptive?: NativeBannerAdaptive
    coordinates: NativeBannerCoordinates
}

const MREC: NativeBannerSize[] = [[300, 250]]
const LEADERBOARD: NativeBannerSize[] = [[728, 90]]
const STICKY: NativeBannerSize[] = [[320, 50]]
const STICKY_TABLET: NativeBannerSize[] = [[320, 90]]
const STICKY_TABLET_WIDE: NativeBannerSize[] = [[728, 90]]

const TABLET_STICKY: NativeBannerVariant[] = [
    { minViewportWidth: 728, sizes: STICKY_TABLET_WIDE },
    { sizes: STICKY_TABLET },
]

const NATIVE_BANNER_SLOTS: Partial<Record<PageAdType, NativeBannerSlot>> = {
    sidebar: { sizes: MREC, coordinates: 'page' },
    sidebar_bottom: { sizes: MREC, coordinates: 'page' },
    sidebar_fullscreen: { sizes: MREC, coordinates: 'page' },
    sidebar_bottom_fullscreen: { sizes: MREC, coordinates: 'page' },
    leaderboard: { sizes: LEADERBOARD, coordinates: 'page' },
    leaderboard_rest: { sizes: LEADERBOARD, coordinates: 'page' },
    widget_sticky_mobile: { sizes: STICKY, coordinates: 'page' },
    sticky_tablet: { sizes: STICKY_TABLET, coordinates: 'page' },
    widget_sticky_tablet: { sizes: STICKY_TABLET, coordinates: 'page' },
    sticky_mobile: { sizes: STICKY, tablet: TABLET_STICKY, coordinates: 'screen' },
    sticky_mobile_non_game_page: { sizes: STICKY, tablet: TABLET_STICKY, coordinates: 'screen' },
}

export function resolveNativeBannerSizes(slot: NativeBannerSlot, viewportWidth: number): NativeBannerSize[] {
    const variant = slot.tablet?.find(({ minViewportWidth = 0 }) => viewportWidth >= minViewportWidth)
    return variant?.sizes ?? slot.sizes
}

export function getNativeBannerSlot(placement: PageAdType, viewportWidth?: number): NativeBannerSlot | undefined {
    const slot = NATIVE_BANNER_SLOTS[placement]

    if (!slot?.tablet || typeof window === 'undefined' || !isBrowserIOSIPadSafari()) {
        return slot
    }

    return { ...slot, sizes: resolveNativeBannerSizes(slot, viewportWidth ?? window.innerWidth) }
}
